import React from 'react';
import { BlueskySocialCircle } from 'components/SocialCircle';
import SocialButton, { SocialButtonProps } from './SocialButton';

export interface BlueskyButtonProps
  extends Pick<
    SocialButtonProps,
    'params' | 'size' | 'disabled' | 'onClick' | 'tooltip'
  > {}

const BlueskyButton: React.FC<BlueskyButtonProps> = ({
  params,
  size,
  disabled,
  onClick,
  tooltip,
}) => (
  <SocialButton
    {...{ params, size, disabled, onClick, tooltip }}
    label="Bluesky"
    icon={<BlueskySocialCircle color="#1085fe" className="bluesky" />}
  />
);

export default BlueskyButton;
